import * as React from 'react';
import { InputFormControl } from 'RtUi/components/form/InputFormControl';
import { IsActiveRadioFormControl } from 'RtUi/components/form/IsActiveRadioFormControl';
import { RadioFormControl } from 'RtUi/components/form/RadioFormControl';
import { RtUiWideForm } from 'RtUi/components/ui/RtUiForm';
import { RespOrgSelect } from '../../../RespOrgs/lib/controls/RespOrgSelect';
import { TemplateResource } from '../resources/TemplateResource';
import { UserActions } from 'RtUi/state/actions/user';
import { Permissions } from 'RtExports/routes';
import {
	RespOrgIndexResponse,
	TemplateProfileResponse,
	TemplateUpdateRequest
} from 'RtModels';
import { Col, Row } from 'react-bootstrap';

interface IEditTemplateProps {
	template: TemplateProfileResponse;
	onSuccess: (newTemplate: TemplateProfileResponse) => void;
}

interface IEditTemplateState {
	displayMode: boolean;
	isSubmitting: boolean;
	error?: any;
	label: string;
	isActive: number;
	isReserveTemplate: number;
	isRoutingTemplate: number;
	isSourceTemplate: number;
	isTargetTemplate: number;
	isAllowedToChangeRouting: boolean;
	respOrg?: RespOrgIndexResponse;
}

export class EditTemplate extends React.Component<
	IEditTemplateProps,
	IEditTemplateState
> {
	public state: IEditTemplateState = {
		displayMode: true,
		isSubmitting: false,
		error: undefined,
		label: '',
		isActive: 0,
		isReserveTemplate: 0,
		isRoutingTemplate: 0,
		isSourceTemplate: 0,
		isTargetTemplate: 0,
		isAllowedToChangeRouting: false
	};

	public componentDidMount() {
		this.loadTemplateToComponent();
	}

	public loadTemplateToComponent(template = this.props.template) {
		const isAllowedToChangeRouting = UserActions.has(
			Permissions.TollFreeLcrManager
		);
		const {
			label,
			isActive,
			isReserveTemplate,
			isRoutingTemplate,
			isSourceTemplate,
			isTargetTemplate
		} = template;

		this.setState({
			label,
			isActive,
			isReserveTemplate,
			isRoutingTemplate,
			isSourceTemplate,
			isTargetTemplate,
			isAllowedToChangeRouting
		});
	}

	public async update(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();

		const { templateName, summary } = this.props.template;
		const templateResource = new TemplateResource();
		const {
			label,
			isActive,
			isReserveTemplate,
			isRoutingTemplate,
			isSourceTemplate,
			isTargetTemplate,
			isAllowedToChangeRouting
		} = this.state;

		this.setState({ isSubmitting: true, error: undefined });

		try {
			const updateReq: TemplateUpdateRequest = {
				label,
				isActive,
				isReserveTemplate,
				summary,
				isSourceTemplate,
				isTargetTemplate
			};

			if (isAllowedToChangeRouting) {
				updateReq.isRoutingTemplate = isRoutingTemplate;
			}

			const newTemplate = await templateResource.update(
				templateName,
				updateReq
			);

			this.setState({ displayMode: true, isSubmitting: false }, () => {
				this.loadTemplateToComponent(newTemplate);

				this.props.onSuccess(newTemplate);
			});
		} catch (error) {
			this.setState({ error, isSubmitting: false });
		}
	}

	public render() {
		const { displayMode } = this.state;
		const { template } = this.props;

		return (
			<RtUiWideForm
				error={this.state.error}
				isSubmitting={this.state.isSubmitting}
				onCancel={() => this.loadTemplateToComponent()}
				onChange={(displayMode) => this.setState({ displayMode })}
				displayMode={displayMode}
				onSubmit={(e) => this.update(e)}
			>
				<Row>
					<Col>
						<InputFormControl
							label="Somos Description"
							displayMode
							value={template.summary}
						/>
					</Col>
					<Col>
						<RespOrgSelect
							displayMode
							onChange={(respOrg) => this.setState({ respOrg })}
							value={this.state.respOrg}
							initialOptionId={template.respOrgId}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<InputFormControl
							label="Label"
							subLabel="(private)"
							displayMode={displayMode}
							onChange={(label) => this.setState({ label })}
							value={this.state.label}
						/>
					</Col>
					<Col>
						<IsActiveRadioFormControl
							label="Status"
							displayMode={displayMode}
							onChange={(isActive) => this.setState({ isActive })}
							hideBothOption
							value={this.state.isActive}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<RadioFormControl<number>
							label="Reserve"
							displayMode={displayMode}
							onChange={(isReserveTemplate) =>
								this.setState({ isReserveTemplate })
							}
							value={this.state.isReserveTemplate}
							options={[
								{
									value: 1,
									label: 'Yes',
									tooltip:
										'Show this template in the “Search” page as a Reserve and Activate option'
								},
								{ value: 0, label: 'No' }
							]}
						/>
					</Col>
					<Col>
						<RadioFormControl<number>
							label="Routing (LCR)"
							displayMode={
								this.state.isAllowedToChangeRouting ? displayMode : true
							}
							onChange={(isRoutingTemplate) =>
								this.setState({ isRoutingTemplate })
							}
							value={this.state.isRoutingTemplate}
							options={[
								{
									value: 1,
									label: 'Yes',
									tooltip:
										'This template is auto-generated by the RouteTrust LCR template generation process'
								},
								{ value: 0, label: 'No' }
							]}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<RadioFormControl<number>
							label="Source"
							displayMode={displayMode}
							onChange={(isSourceTemplate) =>
								this.setState({ isSourceTemplate })
							}
							value={this.state.isSourceTemplate}
							options={[
								{
									value: 1,
									label: 'Yes',
									tooltip:
										'This template is a valid selection for an Alternate Scenario template in a Routing Group'
								},
								{ value: 0, label: 'No' }
							]}
						/>
					</Col>
					<Col>
						<RadioFormControl
							label="Target"
							displayMode={displayMode}
							onChange={(isTargetTemplate) =>
								this.setState({ isTargetTemplate })
							}
							value={this.state.isTargetTemplate}
							options={[
								{
									value: 1,
									label: 'Yes',
									tooltip:
										'This template is a valid selection for the primary Working template of a Routing Group'
								},
								{ value: 0, label: 'No' }
							]}
						/>
					</Col>
				</Row>
			</RtUiWideForm>
		);
	}
}
